import React from "react";
import Container from "../../../utils/Container";
import TourBanner from "../../../assets/banner/tour.png";
import FeaturedTours from "./components/FeaturedTours";
import AllTours from "./components/AllTours";
import useSEO from "../../../utils/seo";
const Tours = () => {
  useSEO({
    title: "Tours | Dhoorbin.com",
    description:
      "Explore our wide range of tours and travel packages to make your next trip unforgettable with Dhoorbin.com.",
    image: `${window.location.origin}/images/tour.png`,
    url: "https://dhoorbin.com/tours",
    canonical: "https://dhoorbin.com/tours",
    keywords:
      "tours, travel packages, vacation deals, holiday trips, adventure tours, guided tours, sightseeing, travel experiences, Dhoorbin.com",
    publisher: "Dhoorbin",
    robots: "index, follow",
    lang: "en",
  });
  return (
    <div className="py-10">
      <Container>
        <div className="space-y-5">
          <div className="w-full h-[150px] lg:h-[400px] overflow-hidden rounded-lg">
            <img
              src={TourBanner}
              alt="Dhoorbin.com | Tours"
              className="w-full h-full object-cover"
            />
          </div>
          <div>
            <FeaturedTours />
          </div>
          <div>
            <AllTours />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Tours;
